import React, { Component } from 'react';
import * as _ from 'underscore';
import { connect } from 'react-redux';

import { CircularProgress } from 'material-ui/Progress';
import CreateNewFolder from '@material-ui/icons/CreateNewFolder';
import HDrawer from '../../common/HDrawer';
import RCDHeader from './CalendarDrawerHeader';
import RCDList from './CalendarDrawerList';
import Preview from '../../designer/components/Preview/Preview';
import EmptyState from '../../common/EmptyState';

import * as ProgramTypes from '../../../state/reducer/calendar/programTypes';
import * as CalendarState from '../../../state/reducer/calendar/calendar';

import Console from '../../../lib/debug';
import SegmentService, {
    EVENTS as SEGMENT_EVENTS
} from '../../../lib/segment/SegmentService';

const calendarCategory = {
    tab: 'calendars',
    title: 'PARENT CALENDARS'
};

const programCategory = {
    tab: 'programs',
    title: 'PROGRAMS'
};

const sessionCategory = {
    tab: 'sessions',
    title: 'SESSIONS'
};

export class CalendarLibraryDrawerClass extends Component {
    state = {
        categories: this.getCategories(this.props),
        tab: this.getCategories(this.props)[0].tab,
        search: ''
    };

    componentWillReceiveProps(nextProps) {
        if (!this.props.open && nextProps.open) {
            this.setState({ tab: this.getCategories(nextProps)[0].tab });
        }
    }

    closeDrawer() {
        CalendarState.showPreview(null, null);
        CalendarState.toggleSideNav(false);
    }

    getCategories(props) {
        let type = props.programType;
        let categories = [];
        if (ProgramTypes.isCalendar(type)) {
            categories = [programCategory, sessionCategory];
        } else if (ProgramTypes.isProgram(type)) {
            categories = [sessionCategory];
        } else {
            categories = [programCategory, sessionCategory, calendarCategory];
        }

        return categories;
    }

    getList = () => {
        let listItems = [...(this.props[this.state.tab] || [])];
        listItems = listItems.filter(li => {
            return (
                li.title &&
                li.title
                    .toLowerCase()
                    .indexOf(this.state.search.toLowerCase()) >= 0
            );
        });
        if (listItems.length && this.props.open) {
            return (
                <RCDList
                    programType={this.props.programType}
                    list={listItems}
                    container={this.$container}
                    onSelect={this.handleItemSelect.bind(this)}
                    onEnterItem={this.handleEnterItem.bind(this)}
                    onLeaveItem={this.handleLeaveItem.bind(this)}
                />
            );
        } else {
            if (this.props.loading) {
                return (
                    <div className="loader">
                        <CircularProgress size={50} />
                    </div>
                );
            } else {
                return <EmptyState text="No items found." />;
            }
        }
    };

    getSubscriptionCount = () => {
        let calendarsAndSubscriptions = this.props.calendars.concat(
            this.props.subscriptions
        );
        let subscriptionsCount = 0;
        _.map(calendarsAndSubscriptions, cal => {
            if (cal.subscribed) {
                cal.subCount == subscriptionsCount;
                subscriptionsCount++;
            }
        });
        return subscriptionsCount;
    };

    handleDrawerChange() {
        CalendarState.toggleSideNav(false);
    }

    handleEnterItem(item, $el) {
        let pos = $el.getBoundingClientRect();
        let type = item.typeElement === 'session' ? 'workout' : null;
        CalendarState.showPreview(item, pos, type);
    }

    handleLeaveItem() {
        CalendarState.showPreview(null, null);
    }

    handlePreviewEnter() {
        CalendarState.cancelPreview();
    }

    handlePreviewLeave() {
        CalendarState.showPreview(null, null);
    }

    handleSearch(searchVal) {
        if (searchVal !== this.state.search) {
            let newState = {
                ...this.state,
                search: searchVal
            };
            this.setState(newState);
        }
    }

    handleItemSelect(item) {
        let type = item.typeElement;
        const {
            team,
            programType,
            calendarInfoTree,
            subscriptionsCount
        } = this.props;

        let isProgram = ProgramTypes.isProgram(programType);
        let daysCount = 0;
        CalendarState.showPreview(null, null);
        if (type !== 'calendar') {
            if (isProgram) {
                daysCount = calendarInfoTree.programLength;
            }
            CalendarState.toggleDrawerCalendarDialog(true, item, daysCount);
        } else {
            if (item.subscribed) {
                CalendarState.toggleDrawerCalendarDialog(true, item);
            } else {
                if (this.getSubscriptionCount() >= 3) {
                    CalendarState.inform(
                        true,
                        'Uh Oh!',
                        // eslint-disable-next-line
                        'You can only have 3 active subscriptions. Please unsubscribe from one or more other programs.'
                    );
                } else {
                    let teamId =
                        [
                            ProgramTypes.TYPES.COACH_ATHLETE_CALENDAR,
                            ProgramTypes.TYPES.INVITED_ATHLETE_CALENDAR,
                            ProgramTypes.TYPES.TEAM
                        ].indexOf(programType) > -1
                            ? team.group_id
                            : team.id;

                    CalendarState.saveCalendar(
                        item,
                        teamId,
                        calendarInfoTree.year,
                        calendarInfoTree.month,
                        subscriptionsCount
                    );

                    SegmentService.track(
                        SEGMENT_EVENTS['AddToCalendarCTA'].key,
                        {
                            sources: 'Web app',
                            ctaLocation: 'Calendar dialogs',
                            ctaText: 'Subscribed to parent calendar'
                        }
                    );

                    this.closeDrawer();
                }
            }
        }
    }

    handleTabChange(value) {
        if (value !== this.state.tab) {
            let newState = {
                ...this.state,
                tab: value
            };
            this.setState(newState);
        }
    }

    render() {
        Console.render('CalendarLibraryDrawer');

        let list = this.getList();
        let headerItems = this.getCategories(this.props);
        let previewPosition = this.props.previewPosition || {
            top: -9999,
            left: -9999
        };

        let exercisePreview = this.props.previewedItem ? (
            <Preview
                type={this.props.previewedItem.typeElement}
                width={300}
                item={this.props.previewedItem}
                position={previewPosition}
                onLeave={this.handlePreviewLeave.bind(this)}
                onEnter={this.handlePreviewEnter.bind(this)}
                fromDrawer={true}
            />
        ) : null;

        return (
            <div>
                {exercisePreview}
                <HDrawer
                    open={this.props.open || false}
                    onClose={this.handleDrawerChange.bind(this)}
                    title="Add From Library"
                    icon={<CreateNewFolder />}
                >
                    <RCDHeader
                        items={headerItems}
                        active={this.state.tab}
                        onChange={this.handleTabChange.bind(this)}
                        onSearch={this.handleSearch.bind(this)}
                    />
                    {list}
                </HDrawer>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        open: state.calendar.uiTree.calendarSideNavOpen,
        sessions: state.library.librarySessionsTree,
        programs: state.library.fixedLengthProgramsTree,
        calendars: state.library.calendarProgramsTree,
        calendarInfoTree: state.calendar.infoTree,
        team: state.calendar.infoTree.team,
        athleteId: state.calendar.infoTree.athleteId,
        programId: state.calendar.infoTree.programId,
        programType: state.calendar.infoTree.programType,
        subscriptions: state.calendar.subscribedTeamsTree,
        previewPosition: state.calendar.uiTree.previewPosition,
        previewedItem: state.calendar.uiTree.previewedItem,
        loading: state.calendar.uiTree.drawerLoading,
        ...ownProps
    };
};

const CalendarLibraryDrawer = connect(mapStateToProps)(
    CalendarLibraryDrawerClass
);

export default CalendarLibraryDrawer;
